import { styled } from '@nextiva/next-ui-components';

export const GroupItems = styled('ul')({
  padding: 0,
});
